export const DIVISION_SET_DATA = 'DIVISION_SET_DATA';
export const DIVISION_SET_LAST_PAGE = 'DIVISION_SET_LAST_PAGE';
export const DIVISION_SET_TOTAL_ROWS = 'DIVISION_SET_TOTAL_ROWS';
export const DIVISION_SET_CURRENT_ROW = 'DIVISION_SET_CURRENT_ROW';
export const DIVISION_SET_RELOAD_DATA = 'DIVISION_SET_RELOAD_DATA';
export const DIVISION_SET_LOADING = 'DIVISION_SET_LOADING';
export const DIVISION_TOGGLE_CREATE_EDIT_MODAL =
  'DIVISION_TOGGLE_CREATE_EDIT_MODAL';
export const DIVISION_TOGGLE_DELETE_MODAL = 'DIVISION_TOGGLE_DELETE_MODAL';
